import * as React from "react";
import type { SVGProps } from "react";
const SvgHelpIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="help_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M512 128a384 384 0 1 0 0 768 384 384 0 0 0 0-768zM42.667 512C42.667 252.8 252.8 42.667 512 42.667S981.333 252.8 981.333 512 771.2 981.333 512 981.333 42.667 771.2 42.667 512zm426.666 213.333A42.667 42.667 0 0 1 512 682.667h.427a42.667 42.667 0 1 1 0 85.333H512a42.667 42.667 0 0 1-42.667-42.667zm-3.968-372.437a85.333 85.333 0 0 1 128.555 73.685v.086c0 20.053-15.573 40.874-45.013 60.501a258.133 258.133 0 0 1-53.163 26.795l-.683.256a42.667 42.667 0 0 0 27.008 80.938l-13.482-40.49c13.482 40.49 13.525 40.448 13.568 40.448h.042l.171-.086.47-.128 1.493-.512 4.949-1.834a343.467 343.467 0 0 0 66.987-34.39c34.56-23.04 82.944-66.133 82.986-131.456a170.667 170.667 0 0 0-331.648-56.874 42.667 42.667 0 0 0 80.47 28.33 85.333 85.333 0 0 1 37.29-45.226z"
    />
  </svg>
);
export default SvgHelpIcon;
